/**
 * SIM-SZENE LEIPZIG – PhasePathIndicator
 * Zeigt aktuelle Spielphase (1–3) und ggf. gewählten Entwicklungspfad.
 */
import { useGameState } from '../state/gameState.jsx';
import './PhasePathIndicator.css';

const PATH_LABELS = {
  verband: 'Verband',
  foerderung: 'Förderung',
  credibility: 'Szene',
};

export function PhasePathIndicator() {
  const { state } = useGameState();
  const phase = state.phase ?? 1;
  const pathId = state.currentPathId ?? null;

  return (
    <span className="phase-path-indicator" aria-label={`Phase ${phase}${pathId ? `, Pfad ${PATH_LABELS[pathId] ?? pathId}` : ''}`}>
      <span className="phase-dots" aria-hidden="true">
        {[1, 2, 3].map((p) => (
          <span
            key={p}
            className={`phase-dot ${p === phase ? 'phase-dot--active' : ''} ${p < phase ? 'phase-dot--done' : ''}`}
          />
        ))}
      </span>
      <span className="phase-path-label">
        {pathId ? PATH_LABELS[pathId] ?? pathId : `Phase ${phase}`}
      </span>
    </span>
  );
}
